<template>
  <WdsText>{{ column.previouslyHired ? $t('Yes') : $t('No') }}</WdsText>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { WdsText } from '@worksome/wds-components'
import { FragmentType, graphql, useFragment } from '@/gql'
import { $t } from '@/app-bootstrapping/SetUpInternationalization'

const EmploymentPreviouslyHiredColumn = graphql(`
  fragment EmploymentPreviouslyHiredColumn on Employment {
    id
    previouslyHired
  }
`)

const props = defineProps<{ row: FragmentType<typeof EmploymentPreviouslyHiredColumn> }>()
const column = computed(() => useFragment(EmploymentPreviouslyHiredColumn, props.row))
</script>
